import React from "react";

import {
  AgreementInstructorDocument,
  LearnerAllocationStatus,
  UserType,
} from "@hubcapp/types";

import { generateNotifications } from "./utils";
import { useAuth } from "@hubcapp/context";
import { useQueryGetAgreementsDocumentsByPerson } from "@hubcapp/views/MyDetails/hooks";
import TodaysThingsToDo from "./TodaysThingsToDo";
import useQueryGetTodaysThingsToDo from "./hooks/useQueryGetTodaysThingsToDo";

const TodaysThingsToDoStateProvider = () => {
  const {
    instructor: { id: instructorId },
  } = useAuth();
  const { data, loading } = useQueryGetTodaysThingsToDo({ instructorId });
  const {
    data: documentsByInstructor,
    loading: loadingDocumentsByInstructor,
  } = useQueryGetAgreementsDocumentsByPerson(instructorId);

  const learners = data?.instructor?.learners || [];

  const pendingLearners = learners.filter(
    ({ allocations, sourcedBy }) =>
      allocations &&
      allocations[0].allocationStatus === LearnerAllocationStatus.Pending &&
      (sourcedBy === UserType.Business || sourcedBy === null),
  );

  const outstandingDocuments: AgreementInstructorDocument[] = [];
  if (documentsByInstructor?.getAgreementsDocumentsByPerson) {
    documentsByInstructor.getAgreementsDocumentsByPerson.forEach(franchise => {
      franchise.documents.forEach(agreement => {
        if (agreement && agreement?.status === "Outstanding") {
          outstandingDocuments.push(agreement as AgreementInstructorDocument);
        }
      });
    });
  }

  return (
    <TodaysThingsToDo
      notifications={generateNotifications({
        numberOfPendingLearners: pendingLearners.length,
      })}
      loading={loading || loadingDocumentsByInstructor}
      outstandingDocuments={outstandingDocuments}
    />
  );
};

export default TodaysThingsToDoStateProvider;
